<template>
  <div class="app-container">
    <div class="mainContainer">
      <!-- tab切换 -->
      <div class="toponsd">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="客户类型" name="one" />
          <el-tab-pane label="经营范围" name="two" />
        </el-tabs>
      </div>
      <div style="margin-bottom: 10px">
        <span class="el-icon-info"></span>
        <span v-if="activeName == 'one'" class="yeler">
          ERP接口传输将传输平台对码转换后的客户类型
        </span>
        <span class="yeler" v-else>
          ERP接口传输将传输平台对码转换后的经营范围
        </span>
      </div>
      <!-- 列表 -->
      <div class="table-container">
        <el-table v-loading="loading" :data="tableData" border height="100%">
          <el-table-column
            prop="platformTypeName"
            :label="activeName == 'one' ? '平台客户类型' : '平台经营范围'"
            align="center"
          />
          <el-table-column
            prop="erpMatchingCode"
            :label="activeName == 'one' ? 'ERP客户类型' : 'ERP经营范围'"
            align="center"
          />
          <el-table-column
            prop="erpMatchingCodeId"
            :label="activeName == 'one' ? 'ERP会员类型ID' : 'ERP经营范围ID'"
            align="center"
          />
          <el-table-column prop="remark" label="备注" align="center">
            <template slot-scope="{ row }">
              {{ row.remark || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="{ row }">
              <span class="btsed" @click="onEdit(row)">对码</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.currPage"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
      />
    </div>

    <!-- 手动对码弹窗 -->
    <el-dialog
      :title="activeName == 'one' ? '客户类型对码' : '经营范围对码'"
      :visible.sync="dialogVisible"
      width="450px"
      :close-on-click-modal="false"
    >
      <el-form ref="codeForm" :model="form" :rules="rules" label-width="150px">
        <el-form-item
          :label="activeName == 'one' ? '平台客户类型：' : '平台经营范围：'"
          prop="platformTypeName"
        >
          <el-input v-model="form.platformTypeName" disabled />
        </el-form-item>

        <el-form-item
          :label="
            activeName == 'one' ? 'ERP客户类型名称：' : 'ERP经营范围名称：'
          "
          prop="erpMatchingCode"
        >
          <el-input
            v-model="form.erpMatchingCode"
            :placeholder="
              activeName == 'one'
                ? '请输入ERP的客户类型名称'
                : '请输入ERP的经营范围名称'
            "
          />
        </el-form-item>

        <el-form-item
          :label="activeName == 'one' ? 'ERP客户类型ID：' : 'ERP经营范围ID：'"
          prop="erpMatchingCodeId"
        >
          <el-input
            v-model="form.erpMatchingCodeId"
            :placeholder="
              activeName == 'one'
                ? '请输入ERP的客户ID'
                : '请输入ERP的经营范围ID'
            "
          />
        </el-form-item>

        <el-form-item label="备注（选填）：">
          <el-input
            v-model="form.remark"
            :placeholder="
              activeName == 'one'
                ? '请输入ERP的客户类型备注'
                : '请输入ERP的经营范围备注'
            "
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onSure" :loading="btnloading">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getMatchingCodeList, //对码管理-对码列表
  editMatchingCode, //对码管理-手动对码
} from "@/api/appApi/appapi.js";
export default {
  name: "",
  data() {
    return {
      activeName: "one", //tab状态
      queryParams: {
        currPage: 1, // 页码
        pageSize: 10, //每页大小
        platformType: 2, // 平台类型(1:经营范围, 2:客户类型, 3:资质类型)
      },
      total: 0,
      loading: false,
      tableData: [], //列表

      dialogVisible: false, //手动对码弹窗
      btnloading: false,
      form: {
        id: "",
        businessId: "",
        platformTypeName: "",
        erpMatchingCodeId: "",
        erpMatchingCode: "",
        remark: "",
      },
      rules: {
        platformTypeName: [
          { required: true, message: "平台字段不能为空", trigger: "blur" },
        ],
        erpMatchingCode: [
          {
            required: true,
            message: "请输入ERP名称",
            trigger: "blur",
          },
        ],
        erpMatchingCodeId: [
          {
            required: true,
            message: "请输入ERP ID",
            trigger: "blur",
          },
        ],
      },
    };
  },

  created() {
    if (this.$route.query) {
      console.log(this.$route.query, "this.$route.query");
    }
    this.getList();
  },
  methods: {
    //序号
    indexMethod(index) {
      index + (this.queryParams.currPage - 1) * this.queryParams.pageSize + 1;
    },
    //查询按钮操作
    handleQuery() {
      this.queryParams.currPage = 1;
      this.getList();
    },
    /** 查询列表数据 */
    async getList() {
      this.loading = true;
      let res = await getMatchingCodeList(this.queryParams);
      this.loading = false;
      if (res.code == "000000") {
        this.tableData = res.content.list;
        this.total = res.content.totalRecords;
      }
    },

    // 对码
    onEdit(row) {
      this.form = {
        id: row.id,
        businessId: row.businessId,
        platformTypeName: row.platformTypeName,
        erpMatchingCodeId: row.erpMatchingCodeId,
        erpMatchingCode: row.erpMatchingCode,
        remark: row.remark,
      };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.codeForm && this.$refs.codeForm.clearValidate();
      });
    },

    // 确认手动对码
    async onSure() {
      const valid = await this.$refs.codeForm.validate().catch(() => false);
      if (!valid) return;
      this.btnloading = true;
      const { businessId, ...data } = this.form;
      let res = await editMatchingCode(data, { businessId });
      this.btnloading = false;
      if (res.code == "000000") {
        this.$message.success("对码成功");
        this.dialogVisible = false;
        this.getList();
      }
    },

    // 重置
    handleReset() {
      Object.assign(this.queryParams, this.$options.data().queryParams);
      this.getList();
    },
    //切换tab状态
    async handleClick() {
      this.queryParams.currPage = 1;
      this.queryParams.platformType = this.activeName == "one" ? 2 : 1;
      await this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__nav-wrap::after {
  background-color: #dfe4ed;
}
.toponsd {
  margin-left: 10px;
  position: relative;
  .abobtn {
    position: absolute;
    top: 0px;
    right: 0px;
  }
}
</style>
